import { action } from 'easy-peasy';
import { IActionAddCarePlanMedications } from '../types';

const addCarePlanMedications: IActionAddCarePlanMedications = action((state, payload) => {
  state.items = [...payload, ...state.items].sort((a, b) => a.name.localeCompare(b.name));
});

export default addCarePlanMedications;
